import store from '~/redux/user/store';
import {addClevertapWhatsAppConsent} from "~/redux/user/actions";

var cleverTapAnalyticsId = (window.settings || {}).cleverTapAnalyticsId

export function initCleverTap() {
  if(cleverTapAnalyticsId){
    window.clevertap = {event:[], profile:[], account:[], onUserLogin:[], notifications:[], privacy:[]};
    // replace with the CLEVERTAP_ACCOUNT_ID with the actual ACCOUNT ID value from your Dashboard -> Settings page
    window.clevertap.account.push({"id": cleverTapAnalyticsId});
    window.clevertap.privacy.push({optOut: false}); //set the flag to true, if the user of the device opts out of sharing their data
    window.clevertap.privacy.push({useIP: false}); //set the flag to true, if the user agrees to share their IP data
    var scriptSrc = ('https:' === document.location.protocol ? 'https://d2r1yp2w7bby2u.cloudfront.net' : 'http://static.clevertap.com') + '/js/a.js';
    (function(i,s,o,g,a,m){
      a=s.createElement(o);m=s.getElementsByTagName(o)[0];a.async=1;a.src=g;m.parentNode.insertBefore(a,m)
    })(window, document, 'script', scriptSrc);    
  }
}

export function trackEvent(eventName, eventData) {
  var clevertap = window.clevertap
  if(clevertap){ clevertap.event.push(eventName, eventData) }
}

export function addUserProfile(profileName, profileData) {
  var clevertap = window.clevertap
  // if(clevertap){ clevertap.profile.push({ [profileName]: profileData }) }
  if(clevertap){ clevertap.onUserLogin.push({ [profileName]: profileData }) }

}

export function logoutUser() {
  var clevertap = window.clevertap
  if(clevertap){ trackEvent('Logout', {'platform' : 'Web'}); clevertap.logout() }
}

export function getPlaySourcePrefix(){
  return window.sessionStorage.getItem('playSourcePrefix') || ''
}

export function setPlaySourcePrefix(prefix){
  window.sessionStorage.setItem('playSourcePrefix', prefix)
}

export function setCurrentPage(page){
  var prevPage = window.sessionStorage.getItem('currentPage')
  window.sessionStorage.setItem('currentPage', page)
  if(prevPage !== page){
    window.sessionStorage.setItem('prevPage', prevPage)
  }
}

export const clevertapWhatsAppConsent = (whatsappConsent, phoneNumber) => {
  const clevertapWhatsappData = {
    whatsappConsent: whatsappConsent, 
    phoneNumber: phoneNumber
  }
  window.settings.features && window.settings.features.whatsappConsent && window.settings.features.whatsappConsent.enableWhatsappConsent && store.dispatch(addClevertapWhatsAppConsent(clevertapWhatsappData))
}
